import { useState } from 'react';

interface ButtonRoundProps {
  text: string;
  onClick: () => void;
  isSelected: boolean;
}

function ButtonRound({ text, onClick, isSelected }: ButtonRoundProps) {
  return (
    <button
      className={`inline-block rounded-lg shadow-md px-5 py-3 text-center text-[0.7rem] ${
        isSelected ? 'bg-[#1a242b] text-white' : 'bg-white text-black'
      } hover:bg-[#1a242b] hover:text-white lg:px-6 lg:py-2 lg:text-[0.7rem]`}
      onClick={onClick}
    >
      <p className="whitespace-nowrap">{text}</p>
    </button>
  );
}

export default ButtonRound;
